<template>
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label>归属电站：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <el-select
                clearable
                v-model="ormtb601id"
                placeholder="请选择"
                @change="stationChange"
              >
                <el-option
                  v-for="item in ormtb601idList"
                  :key="item.ormtb601id"
                  :label="item.ormtb601ca00"
                  :value="item.ormtb601id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="public_oparetionBlock_Menu">
          <label>充电桩编码：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <el-select clearable v-model="ormtb602ca00" placeholder="请选择">
                <el-option
                  v-for="item in pileList"
                  :key="item.ormtb601id"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="public_operatArea">
        <div class="public_operatBtn">
          <button
            @click="queryClick"
            class="public_saleWater_chaxun pulic_cursor"
          >
            搜索
          </button>
          <button class="public_saleWater_daochu pulic_cursor" @click="reset">
            重置
          </button>
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
      >
        <el-table-column prop="ormtb602ca00" label="充电桩编码">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb602ca00 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb603ca00" label="桩号">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb602CA03 }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb603ca00" label="枪号">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.ormtb603CA07 }}</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column prop="faultCode" label="告警代码">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.faultCode }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="faultDesc" label="告警信息">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.faultDesc || '-' }}</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="告警时间">
          <template slot-scope="scope">
            <p>
              <span>{{ scope.row.createTime || '-' }}</span>
            </p>
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageMo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      list: [],
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      solelist: [], //权限列表
      userobj: undefined,
      ormtb601id: '', //站ID
      ormtb602ca00: '', //桩编号
      ormtb601idList: [],
      pileList: [],
    }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    var path = this.$route.path
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))

    this.userobj = this.$store.state.uobj
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表

    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    // 获取数据
    this.ormtb601id = this.$route.query.stationId
    this.ormtb602ca00 = this.$route.query.pileCode
    this.getormtb601idList()
    this.pageList()
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      ormtb608ca01: this.ormtb608ca01,
      ormtb410ca00: this.ormtb410ca00,
      pageMo: this.pageMo,
      limitMo: this.limitMo,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  mounted() {
    // this.pageList()
  },
  methods: {
    //初始化数据
    init() {
      this.ormtb608ca01 = this.historyInfo.ormtb608ca01
      this.ormtb410ca00 = this.historyInfo.ormtb410ca00
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
    },
    //获取站点
    getormtb601idList() {
      var url = '/orm/ormtb601/selecAll601'
      this.axios.post(url).then(res => {
        if (res.data.code == 200) {
          this.ormtb601idList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    // 获取桩列表
    getPileList() {
      var url = '/orm/ormtb611/selectCodeList'
      this.axios.post(url, { ormtb601Id: this.ormtb601id }).then(res => {
        if (res.data.code == 200) {
          this.pileList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    reset() {
      this.ormtb601id = ''
      this.ormtb602ca00 = ''
      this.pageMo = 1
      this.limitMo = 10
      this.tableData = []
      this.pageList()
    },
    // 查询
    queryClick() {
      this.pageMo = 1
      this.limitMo = 10
      this.tableData = []
      this.pageList()
    },
    // 列表
    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ormtb601id: this.ormtb601id,
        ormtb602ca00: this.ormtb602ca00,
        page: this.pageMo,
        limit: this.limitMo,
      }
      var url = '/orm/ormtb611/select611Page'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            var data = res.data.data
            this.tableData = data
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    stationChange() {
      this.ormtb602ca00 = ''
      this.pileList = []
      this.getPileList()
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.el-button + .el-button {
  margin-left: 0px !important;
}

/deep/.el-table td {
  font-size: 14px !important;
}

/* 搜索框 */
.search_box {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 10px 20px;
}

/deep/.el-table .has-gutter tr {
  background: #199fff !important;
}

.public_operatArea {
  display: flex;
  justify-content: end;
}

.pulic_cursor {
  width: 48px !important;
  height: 32px !important;
  line-height: 32px !important;
  text-align: center;
  border-radius: 4px !important;
  padding: 0 !important;
  font-size: 14px !important;
}

.public_operatBtn {
  display: flex;
  justify-content: end;
}

.public_operatBtn_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px !important;
  height: 32px !important;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 20px;
  margin-left: 10px;
}
</style>
